import {httpGet, httpPost} from "../util";

const UserAPI = {
  async postLastAccess() {
    return await httpPost('/api/user/lastaccess',
      result => console.debug("Last access registered", result),
    );
  },
  async getUserProfile() {
    return await httpGet('/api/user/profile', result => result);
  }
};

export default UserAPI;
